import { createContext, use, type ReactNode } from 'react';
import {
  usePreviousGameRoundResults,
  type UsePreviousGameRoundResultsHookResult,
} from '../hooks';

const PreviousRoundResultsContext =
  createContext<UsePreviousGameRoundResultsHookResult | null>(null);

export const PreviousRoundResultsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const previousRoundResults = usePreviousGameRoundResults();

  return (
    <PreviousRoundResultsContext value={previousRoundResults}>
      {children}
    </PreviousRoundResultsContext>
  );
};

export const usePreviousRoundResults = () => {
  const context = use(PreviousRoundResultsContext);
  if (!context) {
    throw new Error(
      'usePreviousRoundResults must be used within a PreviousRoundResultsProvider'
    );
  }
  return context;
};
